import { render, staticRenderFns } from "./four.vue?vue&type=template&id=88ec1d28&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=88ec1d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ec1d28",
  null
  
)

export default component.exports